import dayjs from "dayjs";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { APPOINTMENT_MESSAGE_SENDER_DOCTOR, APPOINTMENT_MESSAGE_SENDER_PATIENT } from "@/constants/appointment";
import { DATE_FORMATS } from "@/constants/date";
import {
  selectAppointmentDoctorName,
  selectAppointmentMessages,
  selectAppointmentPatientName,
} from "@/store/features/appointment/selectors";
import { selectUserData } from "@/store/features/user/selectors";
import { useAppSelector } from "@/store/hooks";
import { Empty } from "@/ui";
import { StyledMessageItem, StyledMessages } from "./styled";

const Messages: FC = () => {
  const {t} = useTranslation();

  const user = useAppSelector(selectUserData);

  const patient = useAppSelector(selectAppointmentPatientName);
  const doctor = useAppSelector(selectAppointmentDoctorName);

  const messages = useAppSelector(
    selectAppointmentMessages,
    shallowEqual,
  );

  const getSenderName = (sender: string) => {
    switch (Number(sender)) {
      case APPOINTMENT_MESSAGE_SENDER_DOCTOR:
        return doctor;
      case APPOINTMENT_MESSAGE_SENDER_PATIENT:
        return patient;
      default:
        return '';
    }
  };

  const renderSender = (sender: string) => {
    const name = getSenderName(sender);

    if (user && name === user.name) {
      return t('you');
    }

    return name;
  };

  return (
    <StyledMessages>
      {messages.length ? messages.map((item) => (
        <StyledMessageItem key={item.id}>
          <h3>{renderSender(item.sender)} <span>{dayjs(item.created_at).format(DATE_FORMATS.dateTime)}</span></h3>
          <p>{item.note}</p>
        </StyledMessageItem>
      )) : (
        <Empty
          title={t('no_messages_available')}
          text={t('no_messages_available_message')}
        />
      )}
    </StyledMessages>
  );
};

export default Messages;
